import { Suspense } from "react";
import "./App.css";
import { Provider, useSelector } from "react-redux";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ProtectedRoute from "./Routes/ProtectedRoute";
import Loader from "./Common/Loader";
import { HeadersPath, path } from "./Utils/ScreenPath";
import Login from "./Pages/Login/Login";
import { store } from "./redux/store";
import SectionPaper from "./Pages/ManuallyGenerate/SectionPaper";
import { NotFound } from "./Pages/NotFound";
import PublicRoute from "./Routes/PublicRoute";
import ManuallyGenerate from "./Pages/ManuallyGenerate/ManuallyGenerate";
import QtypeSection from "./Pages/ManuallyGenerate/QtypeSection";
import QuestionSection from "./Pages/ManuallyGenerate/QuestionSection";
import PdfPreview from "./Pages/PdfPreview";
import AutoGenerate from "./Pages/AutoGenerate/AutoGenerate";
import RandomGenerate from "./Pages/RandomGenerate/RandomGenerate";
import RandomQuestions from "./Pages/RandomGenerate/RandomQuestions";
import Profile from "./Pages/Profile/Profile";
import ProfileInfo from "./Pages/Profile/ProfileInfo";
import PaperHistory from "./Pages/PaperHistory/PaperHistory";
import ReportedQuestions from "./Pages/Profile/ReportedQuestions";
import QuestionReport from "./Pages/Profile/QuestionReport";
import EditPaper from "./Pages/EditPaper";
import ImageUpload from "./Pages/ImageUpload";
import ChatbotWidget from "./Common/Chatbot";
import SamplePaper from "./Pages/SamplePaper/SamplePaper";

function App() {
  const dynamicHeaders = useSelector((state) => state?.HeaderPath?.HeaderPath);
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/*" element={<NotFound />} />
          <Route
            path={path.Login}
            element={<PublicRoute Component={Login} FlowType="Login" />}
          />
          <Route
            path="/"
            element={<PublicRoute Component={Login} FlowType="Login" />}
          />
          <Route path="/imageupload" element={<ImageUpload />} />
          <Route
            path={path.SectionWise}
            element={
              <ProtectedRoute
                Component={SectionPaper}
                HeadersPath={HeadersPath.SectionWise}
                paper_type="manually"
                genrate_type="with section"
              />
            }
          />

          <Route
            path={path.WithoutSection}
            element={
              <ProtectedRoute
                Component={SectionPaper}
                HeadersPath={HeadersPath.withoutSection}
                paper_type="manually"
                genrate_type="without section"
              />
            }
          />

          <Route
            path={path.ManuallyGenerate + "/:isEdit"}
            element={
              <ProtectedRoute
                Component={ManuallyGenerate}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.QTypeWise + "/:sectionIndex/:divisionIndex"}
            element={
              <ProtectedRoute
                Component={QtypeSection}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={
              path.QuestionSection +
              "/:sectionIndex/:divisionIndex/:qtypeId/:chappterId"
            }
            element={
              <ProtectedRoute
                Component={QuestionSection}
                HeadersPath={dynamicHeaders}
              />
            }
          />


          <Route
            path={
              path.Relpace +
              "/:sectionIndex/:divisionIndex/:qtypeId/:chappterId/:replaceId/:EditId"
            }
            element={
              <ProtectedRoute
                Component={QuestionSection}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={
              path.QTypeWise +
              "/:sectionIndex/:divisionIndex/:replaceId/:EditId"
            }
            element={
              <ProtectedRoute
                Component={QtypeSection}
                HeadersPath={dynamicHeaders}
              />
            }
          />


          {/* <Route
            path={
              path.QuestionSection +
              "/:sectionIndex/:divisionIndex/:qtypeId/:chappterId"
            }
            element={
              <ProtectedRoute
                Component={QuestionSection}
                HeadersPath={dynamicHeaders}
              />
            }
          /> */}

          <Route
            path={path.PdfPreview}
            element={
              <ProtectedRoute
                Component={PdfPreview}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.EditPaper}
            element={
              <ProtectedRoute
                Component={EditPaper}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.AutoGenerate}
            element={
              <ProtectedRoute
                Component={AutoGenerate}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.RandomGenerate}
            element={
              <ProtectedRoute
                Component={RandomGenerate}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.SamplePaper}
            element={
              <ProtectedRoute
                Component={SamplePaper}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.RandomGenerateQue}
            element={
              <ProtectedRoute
                Component={RandomQuestions}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.PaperHistory}
            element={
              <ProtectedRoute
                Component={PaperHistory}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.Profile}
            element={
              <ProtectedRoute
                Component={Profile}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.ProfileInformation}
            element={
              <ProtectedRoute
                Component={ProfileInfo}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.ReportedQuestions}
            element={
              <ProtectedRoute
                Component={ReportedQuestions}
                HeadersPath={dynamicHeaders}
              />
            }
          />

          <Route
            path={path.QuestionReport}
            element={
              <ProtectedRoute
                Component={QuestionReport}
                HeadersPath={dynamicHeaders}
              />
            }
          />
        </Routes>
        <ChatbotWidget />
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
